import type { Uuid } from "@/utils"

export enum VerificationStatus {
  Verified = "verified",
  Unverified = "unverified",
  UnverifiedExpired = "unverified_expired",
}

export type User = {
  readonly id: Uuid
  readonly name: string
  readonly initials: string
  readonly nickName: string | null
}

export type LoginRequest = {
  readonly email: string
  readonly password: string
}

export type RegisterRequest = {
  readonly email: string
  readonly password: string
  readonly terms: boolean
}

export type ApplyResetPasswordRequest = {
  readonly token: string
}

export type ResetPasswordPayload = {
  readonly email: string
}

export type ChangePasswordPayload = {
  readonly password: string
}

export type TokenResponse = {
  readonly token: string
  readonly refreshToken: string
  readonly isUnverifiedExpired?: true
}

export enum SocialProvider {
  Google = "google",
  GitHub = "github",
  // Microsoft = "microsoft",
}

export type ConnectRequest = {
  readonly provider: SocialProvider
  readonly returnUrl: string
}

export type ConnectResponse = {
  readonly authUrl: string
}
